import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LoadingService } from '../utils/services/loading.service';


@Component({
  selector: 'app-shopify',
  templateUrl: './shopify.component.html',
  styleUrls: ['./shopify.component.css']
})
export class ShopifyComponent implements OnInit {

  @ViewChild('scrollTarget', { static: true }) scrollTarget: any = ElementRef;

  goToBottom() {
    // window.scrollTo(0, 6000);
    this.scrollTarget.nativeElement.scrollIntoView({ behavior: 'smooth' });

  }

  title = 'Shopify Development Company in Dubai | Pro Web';


  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private loadingService: LoadingService,

  ) { }

  logoarr = ['/assets/img/packages/avea-logo.svg', '/assets/img/packages/uaedriving-logo.svg', '/assets/img/packages/prepme-logo.svg', '/assets/img/packages/carrytune-logo.svg'];
  logoarr2 = ['/assets/img/packages/avea-mobile.png', '/assets/img/packages/prepme-mobile.png', '/assets/img/packages/carry-tune-mobile.png'];

data = [
    'levantiques-logo.webp',
    'kashka.png',
    'audilogo.png',
    'bmwlog.png',
    'mbmlogo.png',
  ];

  datamobile = [
    // 'levantiques-logo.webp',
    // 'kashka.png',
    // 'audilogo.png',
    // 'bmwlog.png',
  ];
  ngOnInit() {
    this.loadingService.setLoadingState(true);

    setTimeout(() => {
      this.loadingService.setLoadingState(false);
    }, 2000)
    this.titleService.setTitle("Shopify Development Company in Dubai | Pro Web");

    this.metaTagService.updateTag(
      { name: "keywords", content: "Shopify Development Company in Dubai" }
    );

    this.metaTagService.updateTag(
      { name: 'description', content: "From Custom Shopify modules to end-to-end Shopify & Shopify Plus Development, Pro Web builds dynamic ecommerce platforms for UAE brands expanding their digital footprint." }
    );

  }

  // seo package click function

  package: any = 1;

  seo(a: any) {
    this.package = a;
  }

   faq = [
      {
      title: 'What is Shopify?',
      des: '<p>Shopify is a comprehensive e-commerce platform that helps you launch, grow, and manage your online business. It allows you to create and customize an online store and sell across various channels such as websites, mobile apps, social media, online marketplaces, physical retail stores, and pop-up shops. With Shopify, you can handle product listings, manage inventory, process payments, and coordinate shipping.</p>',
      isActive: false,
    },
      {
      title: 'What is Shopify Plus?',
      des: '<p>Shopify Plus is the enterprise-level solution from Shopify. It includes all the core features of Shopify but adds advanced capabilities, integrations, and support customized for high-volume businesses. It is built to meet the demands of rapidly growing brands and large-scale operations.</p>',
      isActive: false,
    },
      {
      title: 'What is the difference between Shopify and Shopify Plus?',
      des: '<p>While both Shopify and Shopify Plus offer similar core functionalities, the key difference lies in the level of flexibility and support. Shopify Plus provides more customization options, dedicated support, and advanced tools, making it ideal for larger businesses or those expecting significant growth.</p>',
      isActive: false,
    },
    {
      title: 'What Shopify development services do you offer?',
      des: '<p>We provide complete Shopify development services, including store setup, custom theme design, app development, third-party integrations, and performance optimization.</p>',
      isActive: false,
    },

     {
      title: 'Can you migrate my existing store to Shopify?',
      des: '<p>Yes, we handle seamless store migration from platforms like WooCommerce, Magento, or custom-built sites to Shopify while preserving your data and SEO rankings.</p>',
      isActive: false,
    },
      {
      title: 'Do you provide custom Shopify theme development?',
      des: '<p>Absolutely! We create custom Shopify themes customized to your brand’s identity, ensuring a unique and engaging shopping experience for your customers</p>',
      isActive: false,
    },
      {
      title: 'Can you optimize my Shopify store for better performance?',
      des: '<p>Yes, we improve site speed, enhance UI/UX, and optimize code to ensure faster loading times and a smooth shopping experience.</p>',
      isActive: false,
    },
      {
      title: 'Do you develop Shopify apps?',
      des: '<p>Yes, we build custom Shopify apps to extend store functionality, automate tasks, and enhance user engagement.</p>',
      isActive: false,
    },
      {
      title: 'Do you provide ongoing maintenance and support?',
      des: '<p>We offer post-launch support, bug fixes, security updates, and feature enhancements to keep your Shopify store running smoothly.</p>',
      isActive: false,
    },
      {
      title: 'How long does it take to develop a Shopify store?',
      des: '<p>Timelines vary based on project complexity, but a basic store setup can take a few days, while custom stores and advanced features may take a few weeks.</p>',
      isActive: false,
    },
      {
      title: 'Can you integrate third-party tools and payment gateways?',
      des: '<p>Yes, we integrate payment gateways, CRM tools, shipping solutions, analytics, and other third-party services for a fully functional Shopify store.</p>',
      isActive: false,
    },
      {
      title: 'Do you offer SEO services for Shopify stores?',
      des: '<p>We optimize Shopify stores for search engines by improving site structure, metadata, page speed, and content strategies to boost rankings.</p>',
      isActive: false,
    },
      {
      title: 'How much does Shopify development cost?',
      des: '<p>Pricing depends on your store’s requirements, design complexity, and additional features. Contact us for a custom quote tailored to your business needs.</p>',
      isActive: false,
    },
      {
      title: 'What is the cost of developing a Shopify store?',
      des: '<p>The cost varies based on design complexity, custom features, and integrations. Contact us for a personalized quote.</p>',
      isActive: false,
    },
    {
      title: 'How secure is a Shopify store?',
      des: '<p>Shopify provides SSL encryption, PCI compliance, and fraud prevention measures to ensure a secure shopping experience.</p>',
      isActive: false,
    },
    
  ];

  toggleAccordian(event: any, index: any) {
    this.faq.forEach((item, i) => {
      if (i !== index) {
        item.isActive = false;
      }
    });

    // Toggle the clicked item
    this.faq[index].isActive = !this.faq[index].isActive;
  }

}
